type Logo = {
  width?: number;
};

const Logo = ({ width = 180 }: Logo) => {
  return (
    <div>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src='/images/logo.svg' alt='' width={width} />
    </div>
  );
};

export default Logo;
